export function postJson(url, data, config = {}) {
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    ...config,
    headers: {
      'content-type': 'application/json',
      ...(config.headers || ''),
    },
  }).then(toJson)
}

/**
 * Catches HTTP errors (status codes) and JSON decode errors (invalid JSON).
 * Used as a promise-based interceptor for fetch() requests.
 *
 * eg. fetch(url).then(toJson).then(data => console.log('data', data)).catch(response => console.log('error', response))
 */
export function toJson(response) {
  return response
    .json()
    .catch(error => {
      throw response
    })
    .then(json => {
      if (!response.ok) throw json
      return json
    })
}
